export default {
  general: {
    tip: 'Conseil',
    hello: 'Bonjour',
    back: 'Retour',
    left: 'Gauche',
    right: 'Droite',
    both: 'Les deux',
    side: 'Position de côté',
    flank: 'Côté',
    backside: 'Position postérieure',
    height: 'Hauteur',
    depth: 'Profondeur',
    thickness: 'Épaisseur',
    standard: 'Standard',
    kind: 'Type',
    position: 'Position',
    fixation: 'Fixation',
    material: 'Matériau',
    extension: 'Allongement',
    explanation: 'Explication',
    material_type: 'Type de matériau',
    including_supplement: 'Orthèse plantaire comprise',
    clothe: 'Recouvrement des orthèses',
    type: 'Type',
    model: 'Modèle',
    search: 'Rechercher',
    cancel: 'Annuler',
    send: 'Envoyer',
    ok: 'OK',
    continue_anyway: 'Continuer quand même',
    categorie: 'Catégorie',
    update: 'Une mise à jour est disponible.',
    install_update: 'Mettre à jour',
    user: 'Utilisateur',
    products: 'Produits',
    client_info: 'Données du client',
    agreed_terms: 'J’accepte par la présente {0} et {1}',
    privacy_policy: 'Politique de confidentialité',
    processing_agreement: 'Accord de traitement des données',
    order: 'Commander',
    edit: 'Modifier',
    coming_soon: 'Bientôt disponible',
    add_file: 'Ajouter un fichier',
    salutation_mr: 'M.',
    salutation_mrs: 'Mme',
    terms: 'Conditions générales',
    not_available: 'Temporairement indisponible',
    updated_color: 'Couleur mise à jour',
    manual: 'Catalogue technique',
  },
  alert: {
    text: 'Service indisponible pour maintenance du 31 octobre à 18 h au 3 novembre à 12 h.',
  },
  error: {
    header_api: 'Erreur de communication avec l’API',
  },
  account: {
    customer_portal: 'Portail client',
    title: 'Compte',
    login: 'Se connecter',
    signout: 'Se déconnecter',
    username: 'Nom d’utilisateur',
    password: 'Mot de passe',
    forgotpassword: 'Mot de passe oublié',
    logged_in: 'Vous êtes connecté',
    error: {
      title: 'Identifiants incorrects',
      not_found: 'Combinaison nom d’utilisateur/mot de passe incorrecte',
    },
  },
  flea: {
    liner_note: 'La doublure de l’empeigne et la doublure des quartiers sont toujours réalisées avec une doublure en veau crème.',
    tongue_label_note: 'Toujours sur la première de montage',
    polster_tongue_note: 'Toujours en 3 mm',
  },
  leg_cover: {
    liner_note: 'La doublure est toujours réalisée en chevreaux.',
    supplement_note: 'L’orthèse plantaire est toujours réalisée en type A.',
  },
  liner_shoe: {
    lining_note: 'La fermeture est toujours réalisée avec des crochets.',
    heel_note: 'Le talon est toujours intégré au semelage.',
    sole_note: 'Le semelage est toujours réalisé en EVA de 6 mm.',
    explanation_text: 'En renseignant les options de la phase d’essayage du chausson de doublure, vous obtenez un chausson avec une correction, une semelle en EVA, un talon en EVA et des crochets.',
  },
  bath_shoe: {
    fastening_note: 'La fermeture est toujours réalisée avec une bande velcro et un passant.',
    heel_type_note: 'Le talon est toujours réalisé en talon compensé.',
    sole_note: 'Le semelage est toujours réalisé en EVA de 6 mm.',
  },
  slipper: {
    liner_note: 'La doublure est toujours réalisée en Sanino assorti.',
    heel_type_note: 'Le talon est toujours compensé.',
    sole_note: 'Le semelage est toujours réalisé en EVA de 6 mm.',
  },
  orders: {
    title: 'Menu des commandes',
    synchronise: 'Synchroniser les commandes',
    history: 'Historique des commandes',
    archive: 'Commandes archivées',
    custom: 'Sur mesure',
    history_compatibility_header: 'Commande incompatible',
    history_compatibility_message: 'Cette commande n’est pas compatible avec cette version de l’application. Vérifiez que la commande est correcte.',
    no_results: 'Aucune commande trouvée',
  },
  language: {
    title: 'Changer de langue',
    dutch: 'Néerlandais',
    german: 'Allemand',
    english: 'Anglais',
    french: 'Français',
  },
  form: {
    choose_option: 'Choisissez une option',
    not_available: 'Aucune',
    input_placeholder: 'Saisir…',
    type: 'Type',
    number: 'Numéro',
    errors_heading: 'Le formulaire est incomplet',
    errors_text: 'Certains champs n’ont pas été entièrement renseignés.',
    success_heading: 'Le formulaire est valide',
    success_text: 'Le formulaire est prêt à être envoyé.',
    save: 'Enregistrer',
    select_ok: 'OK',
    select_cancel: 'Annuler',
    undeliverable: '{field} n’est pas disponible',
    tvo_height_too_high: 'La hauteur du TVO est trop élevée.',
    tvo_height_too_high_full: 'La hauteur du TVO dépasse la hauteur de tige sélectionnée, compte tenu du type de bourrelet mousse choisi.',
  },
  order: {
    shafts: 'Tiges',
    existing_model: 'Modèle existant',
    select_image: 'Sélectionner une image',
    remove_shoe_image: 'Supprimer l’image de la chaussure choisie',
    color: 'Couleur',
    colors: 'Couleurs',
    models: 'Modèles',
    all: 'Toutes',
    amount: 'Quantité',
    variant: 'Version',
    extra_layer_thickness: 'Épaisseur de la couche supplémentaire',
    leather_no: 'Cuir {no}',
    leather_info: 'Le cuir est un produit naturel dont la texture et la couleur peuvent différer de la photo et de l’échantillon. Ces variations sont normales.',
    decoration: 'Décoration',
    perforation: 'Perforation',
    complexity_price: 'Fournir une image couleur nette',
    embroidery: 'Broderie',
    lasering: 'Gravure laser',
    lining: 'Doublure',
    sensitive_skin: 'Peau sensible',
    vamp_lining: 'Doublure d’empeigne',
    offset: 'Écart',
    heelpart_lining: 'Doublure des quartiers',
    tongue_reinforcement_add: 'Ajouter un renfort de languette',
    tongue_reinforcement: 'Renfort de languette',
    tongue_label: 'Étiquette de la languette',
    tongue_stiffener: 'Renforcement de la languette',
    lining_vamp: 'Doublure d’empeigne',
    sockshoe: 'Réaliser comme chausson d’habillage',
    sockshoe_description: 'Semelage avec première en Ercoflex et semelle d’usure en cuir brut.',
    lining_vamp_no_stitches: 'Doublure de l’empeigne sans couture',
    heel_panel_lining: 'Doublure des quartiers',
    antislip_heel: 'Antidérapant',
    liner_shoe: 'Chausson de doublure',
    vamp_point: 'Point de claque',
    main_stitches: 'Coutures principales',
    decoration_stitching: 'Coutures décoratives',
    quarter_opening: 'Écartement des quartiers',
    choose_quarter_opening: 'Choisissez la distance entre les quartiers',
    stitching_yarn: 'Fil',
    fastening: 'Fermeture {no}',
    upper_height: 'Hauteur de tige',
    shaft_height_incl_heel: 'Hauteur de tige, hauteur du talon comprise',
    leg_measurements: 'Mesures de la jambe',
    tongue_padding: 'Capitonnage de la languette',
    padded_shaft: 'Capitonnage des quartiers',
    polster_foam: 'Capitonnage / mousse',
    polster: 'Capitonnage',
    polster_upper: 'Capitonnage des quartiers',
    polster_upper_left: 'Capitonnage des quartiers gauches',
    polster_upper_right: 'Capitonnage des quartiers droits',
    polstering: 'Capitonnage',
    polstering_material: 'Matériau pour le capitonnage',
    polster_tongue: 'Capitonnage de la languette',
    heelcollar_polster: 'Bourrelet mousse',
    heelcollar_polster_type: 'Type de bourrelet mousse',
    tongue: 'Languette',
    fixation_tongue: 'Fixation de la languette',
    supplement_type: 'Type d’orthèse plantaire',
    supplement_stiffening: 'Rigidification',
    supplement_thickness: 'Épaisseur de l’orthèse plantaire',
    detailed_supplement_thickness: 'Épaisseur détaillée de l’orthèse plantaire',
    supplement_retaining_wall_height: 'Hauteur du renfort / tuteur',
    supplement_amenity_height: 'Hauteur orthèse',
    detail_drawing: 'Dessin technique',
    thickness_left: 'Épaisseur à gauche',
    thickness_right: 'Épaisseur à droite',
    thickness_front: 'Épaisseur à l’avant',
    bottoming: 'Semelage',
    manufacture_method: 'Méthode de fabrication',
    manufacture_method_note: 'Délai de livraison réduit pour le type A en cas de fraisage',
    manufacture_method_layer: '(Couche supérieure, côté plante du pied)',
    supplement_remark: 'Remarques sur les orthèses plantaires',
    fillsole: 'Semelle d’amplitude',
    innersole: 'Première de montage',
    forefoot_prosthesis: 'Orthèse faux-bout (amputation des orteils)',
    sole_stiffner: 'Renforcement de la première de montage',
    nose_material: 'Matériau du bout dur',
    sole_supply_separately: 'Fournir le semelage séparément',
    nose_length: 'Longueur du bout dur',
    nose_reinforcement: 'Bout dur',
    counter_stiffening: 'Renforcement du contrefort',
    reinforcement_provision: 'Contrefort / À fournir ?',
    heel_stiffener: 'Contrefort',
    heel_stiffener_variant: 'Type de contrefort',
    heel_stiffener_height: 'Hauteur du contrefort',
    last_annotation: 'Suivre tracés sur formes',
    garnish: 'Contreforts en cuir',
    shaft_up_to_and_including_pins: 'Tige jusqu’au montage sur forme',
    shaft_up_to_supply_material: 'Fournir séparément l’ensemble du travail de fond',
    modeling_extension: 'Faire identique au modèle.',
    boarding: 'Bande d’enrobage',
    boarding_front: 'Avant',
    boarding_back: 'Arrière',
    boarding_front_back: 'Avant et arrière',
    welt: 'Trépointe',
    all_welts: 'Toutes les trépointes',
    prefab_bottoming: 'Semelage préfabriqué',
    mid_sole: 'Double / intercalaire',
    no_foot_strike: 'Attention : sans barre de déroulement',
    polstering_note: 'Vérifiez la faisabilité du bourrelet mousse avec la hauteur souhaitée de votre TVO.',
    heel: 'Talon',
    heel_type: 'Type de talon',
    heel_position: 'Position du talon',
    heel_position_supplement: 'Hauteur (mm) sous l’orthèse plantaire',
    heel_position_bottoming: 'Hauteur (mm) dans le semelage',
    heel_color: 'Couleur/matériau du talon',
    primary_color: 'Couleur/matériau principal',
    secondary_color: 'Deuxième couleur talon',
    heel_shore: 'Dureté Shore',
    heel_height: 'Hauteur du talon',
    heel_width: 'Largeur avant du talon',
    copy_left: 'Copier la gauche',
    heel_rolling: 'Arrondi du talon',
    heel_buffer: 'Amorti du talon',
    heel_expansion: 'Évasé du talon',
    medial: 'Interne',
    lateral: 'Externe',
    rolling: 'Barre de déroulement',
    rolling_direction: 'Sens du déroulement',
    rolling_side: 'Barre de déroulement {side}',
    rolling_type: 'Type de barre de déroulement',
    rolling_width: 'Largeur de la ligne de déroulement',
    thickness_toe: 'Épaisseur des orteils',
    thickness_ball: 'Épaisseur aux têtes métatarsiennes',
    thickness_heel: 'Épaisseur au talon',
    thickness_ball_lateral: 'Épaisseur MTP 5',
    thickness_ball_medial: 'Épaisseur MTP 1',
    rocker_wrapped_in_boarding: 'Barre de déroulement intégrée à la bande d’enrobage',
    sole: 'Semelle d’usure',
    toplift: 'Bonbout',
    finishing: 'Finition',
    cover: 'Recouvrement',
    cover_material: 'Matériau de recouvrement',
    polster_material: 'Matériau de capitonnage',
    lasting: 'Retirer les formes (déformer)',
    executor: 'Réaliser par',
    laces: 'Lacets',
    finish_supplement: 'Finition des orthèses plantaires',
    place_cover: 'Poser le recouvrement',
    padding_layer: 'Couche de capitonnage',
    shaft_remark: 'Remarques concernant les tiges',
    bottoming_remark: 'Remarques concernant le semelage',
    remarks: 'Remarques',
    info: 'Informations sur la commande',
    salutation: 'Civilité',
    attachments: 'Pièces jointes',
    last_no: 'Numéro des formes',
    last_note: 'Indiquer le numéro au-dessus des formes',
    customer_name: 'Nom du client',
    confirm_leave_header: 'Annuler les modifications ?',
    confirm_leave_message: 'Voulez-vous vraiment quitter la page de commande ? Les données saisies ne seront pas enregistrées.',
    sent_toast: 'La commande a été envoyée',
    number: 'Commande',
    date: 'Date',
    draft: 'Devis',
    sale: 'Commande client',
    sent: 'Devis envoyé',
    done: 'Bloquée',
    cancel: 'Annulée',
    reorder: 'Commander à nouveau',
    edit: 'Modifier',
    form: 'Formulaire',
    velcro_extra_length: 'Velcro extra long',
    last: 'Forme',
    supplement: 'Orthèse plantaire',
    has_last: 'Formes disponibles',
    supplements: 'Orthèses plantaires',
    foil_shoe: 'Chaussures d’essayage plastique',
    foil_shoe_height: 'Hauteur (orthèse plantaire comprise)',
    foil_shoe_remark: 'Remarques sur les chaussures d’essayage',
    copy_existing_last: 'Copier la forme existante',
    deliver: 'À fournir',
    deliver_note: 'Quels documents envoyez-vous ou ajoutez-vous ?',
    cast: 'Moulage',
    blueprint: 'Empreinte papier',
    lutracad: 'Lutracad',
    techmed: 'Scan ZSM',
    modeled_file: 'Fichier modélisé',
    scan_upload: 'Scan (votre propre fichier)',
    techmed_scan: 'Scan ZSM fourni',
    last_type: 'Type de forme',
    last_same_length: 'Formes de même longueur',
    encore: 'Aisance / prolongement du bout',
    encore_division: 'Longueur de forme {side}',
    leg_position: 'Axe de la jambe',
    fabric_edge: 'Bord franc au talon',
    nose_shape: 'Type de bout',
    last_remark: 'Remarques sur les formes',
    sizing: 'Mesures',
    leg_sizes: 'Circonférences de la jambe',
    height_measurement: 'Mesures de hauteur',
    circumferences: 'Circonférences du pied',
    circumferences_no: 'Circonférences du pied {no}',
    foot_measurements: 'Corrections de la surface plantaire',
    position_toes: 'Position des orteils',
    height_toes: 'Hauteur',
    depth_toes: 'Décharge',
    mtp_joints: 'Articulations MTP',
    depth_position: 'MTP {no}',
    lateral_and_medial_gel: 'Pression sous les voûtes externes et internes',
    medial_gel: 'Pression sous la voûte interne',
    lateral_gel: 'Pression sous la voûte externe',
    imprint_base_back: 'Empreinte arrière Base V',
    forefoot_support: 'Appui rétrocapital',
    forefoot_support_instructions: 'Reporter sur l’orthèse plantaire',
    t_pad: 'Pelote en T',
    transversal: 'Appui transversal BRC',
    forefoot_and_heel_bone: 'Pronation et supination',
    pronation_front: 'Pronation de l’avant-pied',
    pronation_back: 'Pronation postérieure',
    suppination_front: 'Supination de l’avant-pied',
    suppination_back: 'Supination postérieure',
    lasts_supplements_foils: 'Formes, orthèses plantaires et chaussures d’essayage',
    finish: 'Finition',
    classics: 'Classiques',
    flea: 'Chaussure post-opératoire',
    leg_cover_remark: 'Remarques sur la gaine de jambe',
    orthotics: 'Orthèses',
    functional: 'Fonctionnel',
    heel_instep: 'Talon / cou-de-pied',
    high_instep: 'Haut cou-de-pied',
    low_instep: 'Bas cou-de-pied',
    ball: 'Métas',
    toe_jump: 'Relevé du bout',
    heel_lift: 'Relevé talonnier',
    heel_thickness: 'Épaisseur au talon',
    toe_no: 'Orteil {no}',
    dimensions: 'Dimensions',
    order_status: 'Statut de la commande',
    confirm_osa_header: 'Nombre maximal de chaussures orthopédiques sur mesure dans le panier',
    confirm_osa_message: 'Voulez-vous vider le panier et commencer une nouvelle commande ?',
    confirm_osa_button_ok: 'Vider le panier',
    paper_between_wedge_impact_and_sole: 'Papier entre la trépointe et le semelage',
    paper_between_wedge_impact_and_sole_explanation: 'Couche de séparation en papier pour les corrections : une couche de papier est placée entre la trépointe et le semelage. Elle facilite la séparation des éléments afin de pouvoir fixer facilement un appareillage.',
    leg_cover: 'Gaine de jambe',
    trial_shoe: 'Chaussure d’essayage',
    bath_shoe: 'Chaussure de bain',
    slipper: 'Chaussure d’intérieur',
    basics: 'Basics',
    osb: 'Thérapeutique et modulaire',
    size_charts: 'Tableaux des pointures',
    kind: 'Type',
    thickness_no: 'Épaisseur {no}',
    changed_color_remark: 'La couleur {color} a été modifiée',
  },
  cart: {
    title: 'Panier',
    order: 'Vous commandez pour',
    empty: 'Votre panier est vide',
    added_header: 'Produit ajouté',
    added_subHeader: 'pour {customer}',
    added_text: 'Souhaitez-vous commander un autre produit pour ce client ?',
    added_continue_shopping: 'Commander un autre produit',
    add_product: 'Ajouter un produit',
    added_finish_order: 'Accéder au panier',
    last_supplement_or_foil: 'Forme, orthèse plantaire ou chaussure d’essayage',
    finish: 'Finition',
    custom: 'Sur mesure',
    send_header: 'Envoyer la commande ?',
    send_text: 'Attention : vérifiez soigneusement que la commande a été correctement remplie.',
    send_ok: 'Oui, envoyer la commande',
    submitting_order: 'Traitement de la commande',
    submitting_line: 'Traitement de la ligne {index} sur {total}',
    submitting_attachment: 'Traitement de la pièce jointe {index} sur {total}',
    new_order: 'Nouvelle commande',
    confirm_empty_header: 'Voulez-vous vraiment supprimer les données du client et vider le panier ?',
    confirm_empty_button_ok: 'Recommencer',
    edit_client_info: 'Modifier les données du client',
    production_order: 'Faites glisser les produits pour modifier l’ordre de production.\nLa commande est traitée de haut en bas.',
    verify_order: 'Vérifiez toutes les lignes de commande à l’aide de l’icône d’engrenage.',
    verify_order_label: 'Vérification de la ligne de commande',
  },
};
